module.exports = fox._r("images/pirates/gift-117.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/pirates/gift-117.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/pirates/gift-117.png
// module id = 341
// module chunks = 4